import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { AutoBookProfile } from "@app/models/rest/auto-book-profile";

@Injectable({
  providedIn: "root"
})
export class AutoBookProfileRestService extends HateoasResourceOperation<AutoBookProfile> {
  constructor() {
    super(AutoBookProfile);
  }
}
